import type { UpdatePsdInputInterface } from 'containers/PropertyPanel/Cards/Feed/PsdTable';
import { PsdTable } from 'containers/PropertyPanel/Cards/Feed/PsdTable';
import PropertyPanelAccordion from 'containers/PropertyPanel/components/PropertyPanelAccordion';
import { preDefinedFlowSizes } from 'util/outputFlowCalculations';
import { useSelector } from 'react-redux';
import { getReverseSizeGradiation } from 'store/settings/selectors';
import { useEditFlowProperties } from '../useEditFlowProperties';
import { CONVERSIONS } from 'util/conversions';
import type { FlowPropertiesProps } from '../withFlowProperties';
import { withFlowProperties } from '../withFlowProperties';

type Props = FlowPropertiesProps;

const SizeGradation = ({ id, activeUnit, flowProperties }: Props) => {
  const showReverseSizeGradation = useSelector(getReverseSizeGradiation);
  const { setValues } = useEditFlowProperties(id, activeUnit, flowProperties);

  const { size, psdName, otherPsdName } = flowProperties;

  const updatePsd = ({ name, size }: UpdatePsdInputInterface) => {
    const custom = 'Custom';
    let newOtherPsdName = otherPsdName;
    let newPsdName = psdName;
    if (name !== custom) {
      newOtherPsdName = `${custom} - ${name}`;
      newPsdName = custom;
    }

    setValues({
      size: showReverseSizeGradation ? [...size].reverse() : size,
      psdName: newPsdName,
      otherPsdName: newOtherPsdName,
    });
  };

  const changePsd = (selected: string) => {
    const preDefinedData = preDefinedFlowSizes.find(
      (material) => material.name === selected,
    );
    let newSize = size;
    if (typeof preDefinedData !== 'undefined') {
      newSize = showReverseSizeGradation
        ? [...preDefinedData.size].reverse()
        : preDefinedData.size;
    }
    setValues({
      psdName: selected,
      size: newSize,
    });
  };

  return (
    <PropertyPanelAccordion title='Size Gradation'>
      <PsdTable
        percent={showReverseSizeGradation ? [...size].reverse() : size}
        size={showReverseSizeGradation ? [...size].reverse() : size}
        psdName={psdName}
        otherPsdName={otherPsdName}
        updatePsd={updatePsd}
        changePsd={changePsd}
        curveEditIndex={-1}
        materialOptions={preDefinedFlowSizes.map((material) => material.name)}
        conversionType={CONVERSIONS.MILLIMETERNOROUNDCONV}
        hidePsd
        hideOtherName
      />
    </PropertyPanelAccordion>
  );
};

export default withFlowProperties(SizeGradation);
